// extracted by mini-css-extract-plugin
export default {"wrapper":"DatePicker_wrapper__KUQjm","clickableBlock":"DatePicker_clickableBlock__DN7tb","value":"DatePicker_value__sm0cq","downIcon":"DatePicker_downIcon__cm-FE"};